import { FC } from 'react';

import { useEmployeeQuery as useQuery } from '@jbc-year-end-adj/2024/hooks/graphql/useQuery';
import { Question } from '@jbc-year-end-adj/2024/features/questions/types';
import { LoadingPage } from '../../Loading';
import { OTHER_FAMILIES, QueryResult } from './query';
import { Form } from './Form';

type DependentsProps = {
  question: Question;
};

export const Dependents: FC<DependentsProps> = ({ question }) => {
  const { data, loading } = useQuery<QueryResult>(OTHER_FAMILIES, { fetchPolicy: 'network-only' });
  if (loading) return <LoadingPage />;
  if (!data) throw Error;

  const {
    clientSetting: {
      requestImageUploadSettings: { handicap: handicapImageSetting, nonResidentAndStudyAbroad: nonResidentAndStudyAbroadImageSetting }
    }
  } = data;

  return (
    <Form
      question={question}
      profile={data.request.profile}
      handicapImageSetting={handicapImageSetting}
      nonResidentAndStudyAbroadImageSetting={nonResidentAndStudyAbroadImageSetting}
    />
  );
};
